import { DataGrid, GridColDef, GridRowParams } from '@mui/x-data-grid';
import { GridPanel, dataGridDefaults } from './list-grid-panel';

interface PagedGridProps {
    columns: GridColDef[];
    // Resultado do usePagedList
    list: { rows: any[]; rowCount: number; loading: boolean };
    parameters: { page: number; pageSize: number };
    onPaginationChange: (page: number, pageSize: number) => void;
    addLabel: string;
    onAdd: () => void;
    rowHeight?: number;
    // Clique na linha (ex.: abrir o detalhe); as ações da linha devem interromper a propagação
    onRowClick?: (row: any) => void;
}

// Grade paginada no servidor com o botão "+" de cadastro, padrão das telas de consulta
export function PagedGrid({ columns, list, parameters, onPaginationChange, addLabel, onAdd, rowHeight, onRowClick }: PagedGridProps) {
    return (
        <GridPanel addLabel={addLabel} onAdd={onAdd}>
            <DataGrid
                {...dataGridDefaults}
                rows={list.rows}
                columns={columns}
                loading={list.loading}
                rowCount={list.rowCount}
                paginationMode="server"
                paginationModel={{ page: parameters.page, pageSize: parameters.pageSize }}
                onPaginationModelChange={(model) => onPaginationChange(model.page, model.pageSize)}
                rowHeight={rowHeight}
                onRowClick={onRowClick ? (params: GridRowParams) => onRowClick(params.row) : undefined}
                sx={onRowClick ? { ...dataGridDefaults.sx, '& .MuiDataGrid-row': { cursor: 'pointer' } } : dataGridDefaults.sx}
            />
        </GridPanel>
    );
}
